import React from "react";
import {TouchableOpacity} from "react-native";
import MainStyle from "../../MainStyle";
import {toCapitalize} from "../utils";
import {colors} from "../assets/styles/colors";
import {MaterialIcons} from "@expo/vector-icons";
import Div from "../lib/Div";
import P from "../lib/P";
import {FormikErrors} from "formik";

type Props = {
  value: string, mt?: string | number, w?: string | number,
  error?: string | boolean | null | string[] | FormikErrors<any> | FormikErrors<any>[], mb?: string | number,
  onChange: (val: 'left' | 'right') => void, mx?: string | number
};

const Handedness = (props: Props) => {
  const {value, mt, w, error, mx, mb} = props;

  return (
    <Div mt={mt} w={w} mx={mx} mb={mb}>
      <P ta="center" fs={12} opacity={0.5}>HANDEDNESS</P>

      <Div row borderWidth={1} rounded={200} h={66} justifyContent="center"
           borderColor={error ? colors.newDangerText : colors.settings_border}>
        <TouchableOpacity style={[MainStyle.row, MainStyle.a_i_c]} onPress={() => props.onChange('left')}>
          <MaterialIcons name={`radio-button-${value === 'left' ? 'on' : 'off'}`} size={18} color="white"/>
          <P fw="500" fs={18} ml={15}>Left</P>
        </TouchableOpacity>

        <Div w={83}/>

        <TouchableOpacity style={[MainStyle.row, MainStyle.a_i_c]} onPress={() => props.onChange('right')}>
          <MaterialIcons name={`radio-button-${value === 'right' ? 'on' : 'off'}`} size={18} color="white"/>
          <P fw="500" fs={18} ml={15}>Right</P>
        </TouchableOpacity>
      </Div>

      <P flex={1} ta="center" fw="500" fs={8} lh={9} color={colors.newDangerText}>{toCapitalize(error as string)}</P>
    </Div>
  );
};

export default React.memo(Handedness);
